
import {
    ref,
    defineComponent,
    computed,
    watch,
    reactive,
    onMounted,
    toRaw,
} from 'vue'
import { useStore } from 'vuex'
import {
    setMenuPermissions,
    getMenuPermissions,
    permissionList,
    add,
} from '../request'
import { message } from 'ant-design-vue'
import { Form } from '../type'

export default defineComponent({
    setup(props, { emit }) {
        const store = useStore()
        const formRef = ref()
        const detail: any = computed(() => store.state.menu.detail)
        let moduleList = ref([])
        const form: any = reactive<Form>({
            name: '',
            menuCode: '',
            remark: '',
            menuUrl: '',
            isDashboard: 0
        })
        const init = () => {
            if (detail.value && detail.value.action == 'mod') {
                Object.assign(form, {
                    menuCode: detail.value.code,
                    name: detail.value.name,
                    remark: detail.value.remark,
                    menuUrl: detail.value.url,
                    isDashboard: detail.value.isDashboard
                })
            }
        }
        const rules = {
            name: [
                {
                    required: true,
                    message: '请输入菜单名称',
                },
            ],
            menuCode: [
                {
                    required: true,
                    message: '请输入菜单编号',
                },
            ],
        }
        const loading = ref<boolean>(false)
        const afterClose = () => {
            store.commit('toggleMenuSetMenuState', false)
            store.commit('setMenuDetail', null)
        }
        /**
         * 获取菜单树
         */
        const fetchMenuTree = async () => {
            let res = await permissionList({})
            let data = res.data
            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    data[key].checked = false
                    data[key].expand = false
                    data[key].checkedList = []
                }
            }
            moduleList.value = data
            // 编辑回填模块权限
            if (detail.value.action === 'mod') {
                let codes = detail.value.permissions
                for (let key in moduleList.value) {
                    let module: any = moduleList.value[key]
                    module.permissions.forEach((item) => {
                        if (codes && codes.indexOf(item.code) > -1) {
                            module.checkedList.push(item.code)
                        }
                    })
                    if (module.checkedList.length) {
                        if (
                            module.checkedList.length <
                            module.permissions.length
                        ) {
                            // 有权限的模块都展开
                            module.expand = true
                            module.isIndeterminate = true
                        } else if (
                            module.checkedList.length ==
                            module.permissions.length
                        ) {
                            module.checked = true
                            module.expand = true
                        }
                    }
                }
            }
        }
        const fetchDetail = async () => {
            let res = await getMenuPermissions({
                menuCode: detail.value && detail.value.code,
            })
            let codes = res.data.permissionCodes
            detail.value.permissions = codes
        }

        function expand(node: any) {
            node.expand = !node.expand
        }
        function changeModuleSelected(item: any) {
            item.isIndeterminate = false
            if (!item.checked) {
                item.checkedList = []
                item.permissions.forEach((m) => {
                    item.checkedList.push(String(m.code))
                })
            } else {
                item.checkedList = []
            }
            item.checked = !item.checked
        }
        /**
         * 改变子模块的选中状态
         */
        function changeSubModule(parent, sub) {
            setTimeout(() => {
                let checkedList = parent.checkedList
                if (checkedList.length) {
                    if (checkedList.length === parent.permissions.length) {
                        parent.isIndeterminate = false
                        parent.checked = true
                    } else {
                        parent.isIndeterminate = true
                        parent.checked = false
                    }
                } else {
                    parent.isIndeterminate = false
                    parent.checked = false
                }
            })
        }
        const onSubmit = () => {
            formRef.value.validate().then(async () => {
                let formValue = toRaw(form)
                if (formValue.isDashboard && !formValue.menuUrl) {
                    message.warning('数据看板url不能为空')
                    return
                }
                var request =
                    detail.value.action === 'mod' ? setMenuPermissions : add
                let params = {
                    permissionCodes: getPermissions(),
                    name: formValue.name,
                    remark: formValue.remark,
                    url: formValue.menuUrl,
                    isDashboard: formValue.isDashboard
                }
                // 编辑
                if (detail.value.action === 'mod') {
                    Object.assign(params, {
                        menuCode: detail.value.code,
                    })
                } else {
                    Object.assign(params, {
                        parentCode: detail.value.code,
                        menuCode: formValue.menuCode,
                    })
                }
                loading.value = true
                try {
                    await request(params)
                } catch (e) {
                    loading.value = false
                }
                loading.value = false
                emit('success')
                message.success('保存成功')
                afterClose()
            })
        }
        // 获取选中的modules
        function getPermissions() {
            let permissionCodes = []
            let list: any = moduleList.value
            for (var i = 0; i < list.length; i++) {
                if (list[i].checkedList && list[i].checkedList.length) {
                    permissionCodes = permissionCodes.concat(
                        list[i].checkedList.filter((item) => {
                            return item
                        })
                    )
                }
            }
            return permissionCodes
        }
        watch(detail, () => {
            init()
        })
        onMounted(async () => {
            if (detail.value.action === 'mod') {
                await fetchDetail()
            }
            await fetchMenuTree()
        })
        init()
        return {
            form,
            store,
            loading,
            onSubmit,
            afterClose,
            detail,
            moduleList,
            formRef,
            expand,
            rules,
            changeModuleSelected,
            changeSubModule,
            value: ref(['A']),
        }
    },
})
